import type { LucideIcon } from 'lucide-react'

interface SectionCardProps {
  title: string
  description: string
  icon: LucideIcon
  children: React.ReactNode
}

export function SectionCard({
  title,
  description,
  icon: Icon,
  children,
}: SectionCardProps): React.ReactElement {
  return (
    <div className="overflow-hidden rounded-lg border border-stone-200 bg-white dark:border-stone-700 dark:bg-stone-800">
      <div className="border-b border-stone-200 px-6 py-4 dark:border-stone-700">
        <div className="flex items-center gap-3">
          <div className="rounded-lg bg-[#4e5e82]/10 p-2 dark:bg-[#8a9bba]/15">
            <Icon className="h-5 w-5 text-[#5c6e94] dark:text-[#8a9bba]" />
          </div>
          <div>
            <h3 className="text-lg font-medium text-stone-900 dark:text-stone-100">{title}</h3>
            <p className="text-sm text-stone-500 dark:text-stone-400">{description}</p>
          </div>
        </div>
      </div>
      <div className="p-6">{children}</div>
    </div>
  )
}
